import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Website from './pages/Website';
import PrivacyPolicy from './pages/Privacy';
import { TranslationProvider } from './context/TranslationContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { CookieConsentBanner } from './components/CookieConsent';
import { usePageTracking } from './hooks/usePageTracking';

function App() {
  const pathname = window.location.pathname;
  const hostname = window.location.hostname;

  const getLang = () => {
    if (pathname.startsWith('/ro')) return 'ro';
    if (pathname.startsWith('/en')) return 'en';
    if (pathname.startsWith('/hu')) return 'hu';
    if (hostname.includes('avocat')) return 'ro';
    return 'hu';
  };

  const lang = getLang();

  return (
    <ErrorBoundary>
      <TranslationProvider lang={lang}>
        <Router>
          <AppContent />
        </Router>
      </TranslationProvider>
    </ErrorBoundary>
  );
}

function AppContent() {
  usePageTracking(); // Automatically tracks page views

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Website />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/hu/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/en/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/ro/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/hu" element={<Website />} />
        <Route path="/en" element={<Website />} />
        <Route path="/ro" element={<Website />} />
      </Routes>
      <CookieConsentBanner />
    </div>
  );
}

export default App;